import React from 'react';
import ShowLazyPanel from './ShowLazyPanel';

export default function SwitchLazyPanel(props) {
    
    const [selKeyRef, setSelKeyRef] = React.useState(null);
    
    React.useEffect(() => {
        setSelKeyRef(props.selKeyRef)
    }, [props.selKeyRef])

    return (
        <div>
            {props.itemsPanels.map((panel, indice) => {
                return (<ShowLazyPanel {...panel} show={selKeyRef === panel.keyRef}  key={'slp' + indice} color={props.color}/>)
            })}
        </div>
    );
}

SwitchLazyPanel.defaultProps = {
    itemsPanels: []
    ,selKeyRef: ''
    ,color: "secondary"
}